import cjson from 'compressed-json';
import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { environment } from "../../../environments/environment";
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, Subject } from 'rxjs';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';
import { FusionChartsService } from 'src/app/_services/fusion-charts.service';
import { JdDataService } from 'src/app/jd-data.service';
import * as _ from 'underscore';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';


declare var google;
const CONTINENT_MAP = {
  "asia": "142",
  "south america": "005",
  "north america": "021",
  "africa": "002",
  "oceania": "009",
  "europe": "150"
}
@Component({
    selector: 'app-report-location-tab',
    templateUrl: './report-location-tab.component.html',
    styleUrls: ['./report-location-tab.component.scss'],
    standalone: false
})
export class ReportLocationTabComponent implements OnInit {

  constructor(private fusionChartService: FusionChartsService, private personSearchService: PersonSearchService, private location: Location, private localstorageservice: LocalStorageService,
    private router: Router, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService,
    private filterDataHandlerService: FilterDataHandlerService,
    private hashService: HashService, private talentInsightsService: TalentInsightsService, private jdService: JdDataService, private route: ActivatedRoute) {

    const statemanagementSub = this.location.subscribe((p) => {
      const urlParams = new URLSearchParams(p.url.split('?')[1]);
      const filterKey = urlParams.get('filter');
      if (filterKey) {
        const cacheRequest = localStorage.getItem(filterKey);
        if (cacheRequest) {
          const filterData = cjson.decompress(JSON.parse(cacheRequest));
          this.filterDataHandlerService.setFilterData(filterData);
        }
      }
      this.setUpdatedData();
    });
  }

  companyDetails: any;
  currentCompanyName: any;
  dataSourceWorkCountry: any = [];
  topLocations: any[] = [];

  locations: any = [];
  locationsData: any = [];
  @ViewChild('locationTbSort') locationTbSort: MatSort;

  displayedColumns: string[] = ['key', 'doc_count', 'recent_hires', 'job_doc_count', 'median_salary'];
  aggregatescount: number = 50;
  pagination: boolean = true;

  /**Size of page */
  pageSize = 10;
  /**Starting index in each page */
  start: number = 0;
  /**Ending page in each page */
  end: number = 10;
  /**current page */
  currentPage = 1;
  /** Total data points */
  totalCount = 0;
  /** */
  locationAPiCalled: boolean = false;
  talentfilterdata: any = {};
  selectedContinent: string = 'World';

  subscriptions: Array<Subscription> = [];
  /**Sorted data of total pages */
  locationSortData: any;
  locationsdataAI: any;
  totalResultCount: number = 0;

  insightsExportSubscription: Subscription = null;

  /**
   * Mapping of key and text value of headers
   * In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
   */
  tableHeaderObj = {
    "TopCities": "Top Locations",
    "TalentCount": "Talent Count",
    "1yrGrowth": "1 yr Growth",
    "JobDemand": "Job Posts",
    "MedianSalary": "Salary Range"
  }

  /**
   * Used to send as payload for export pdf.
   * Use key that need to be shown in pdf.
   * Must follow correct order as used in HTML file
   */
  tableHeaderName: string[] = [];
  combinedAggregates: any;
  combinedIndustry: any[] = [];
  combinedSkills: any[] = [];
  combinedJobtitle: any[] = [];
  combinedLocation: any[] = [];
  hasJobDemand: boolean = false;
  currencyData: any;
  filteredCurrencies: any[] = [];
  hasMedianSalary: boolean = false;

  get isLocationEurope() {
    const hasEUTIAccess = this.localstorageservice.getItem('hasEUTalentInsightsAccess');
    const hasEUPSAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess')

    if (!hasEUPSAccess)
      return this.localstorageservice.getItem('talentRegion') == 'europe';
  }
  currency: string;
  selectedCurrency: any;
  target_currency_rate: number = 1;
  target_fav_icon: string = 'fa-dollar-sign';
  target_currency_symbol: string = '$';
  median_salary_min: number = 0;
  median_salary_max: number = 0;
  aiSuggestions: any;
  filterData: any;
  locationJobAggregates: any;
  filterType: string[] = [];
  isComingFromJD: Boolean = false;
  isComingFromNLSearch: Boolean = false;
  sendDataToSliderSubject: Subject<any> = new Subject();
  toOpenSliderFromTabSubject: Subject<any> = new Subject();
  isOpen = false;
  locationTabPayload:any
  hasJobListingAccess:any;
filters: any;

  ngOnInit(): void {

        if (this.jdService.isComingFromJobDescription) this.isComingFromJD = true;
    if (this.jdService.isComingFromNLSearch) this.isComingFromNLSearch = true;
    this.getCurrencyData()

    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      this.filterData = _methodDetails;

      this.getCurrencyData('filterChange')
    });
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string, } }) => {
      if (requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);

    // Trigger when filters of jd serach will get updated
    const jdUpdateEvent = this.jdService.getInsightsEvent().subscribe((res: any) => {
      if (res.action == 'refresh' && res.tab === this.talentInsightsService.INSIGHTS_TABS.LOCATION) {
        this.filterType = res.filterType;
        this.getCurrencyData('jdUpdate');
      }
    });
    this.subscriptions.push(jdUpdateEvent);

    this.router.events.subscribe(e => {
      const navigation = this.router.getCurrentNavigation();
      // We are getting this value mostly undefined. Could be because of mostly removing use of talentfilterdata in previous tab.
      this.talentfilterdata = navigation.extras.state;
    });

    const aiSuggestionSub = this.talentInsightsService.aiSuggesionData.subscribe(data => {
      this.aiSuggestions = data;
      if (!this.aiSuggestions) {
        this.aiSuggestions = this.talentInsightsService.getAISuggestionData();
      }
      this.getCurrencyData('filterChange');
    });
    this.subscriptions.push(aiSuggestionSub);

    this.hasJobListingAccess = this.localstorageservice.getItem('hasjoblistingaccess')
  }


  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) {
      this.talentfilterdata = talentFilterData;
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    this.personSearchService.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)
    this.getTopLocationsV2();
    const aggReq = this.aggService.getRequestWithFilters();

    if ((!this.filterData && this.filterType?.length == 0) || (this.filterData?.filterType == 'location' || this.filterData?.filterType == 'industry' || this.filterData?.filterType == 'company' || this.filterData?.filterType == 'seniority' || this.filterData?.filterType == 'function' || this.filterData?.filterType == 'locationRange' || this.filterData?.filterType == 'skills' || this.filterData?.filterType == 'jobtitle' || this.filterData?.filterType == 'keyword' || this.filterData?.filterType == 'search' || this.filterData?.filterType == 'pastjobtitle') ||
      ((this.filterType?.length > 0 && (this.filterType.includes('skills') || this.filterType.includes('jobtitle') || this.filterType.includes('industry') || this.filterType.includes('company'))))) {
        this.getCurrency();
    } else if(this.filterData?.filterType == 'allfilters' && !this.isComingFromJD && !this.isComingFromNLSearch){
       this.locationSortData.map(location => {
        location.median_salary = "N/A";
        location.confidence_score = "N/A";
        location.job_doc_count = 0;
        return location;
      });

      this.localstorageservice.setItem('jobCurrency', 'USD');
          this.localstorageservice.setItem('currencyCountry', null);
              this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
      this.currencyData = response?.data;
      this.filteredCurrencies = this.currencyData.slice(0, 5);
      const currency = this.localstorageservice.getItem('jobCurrency');
      if (currency) {
        const selectedCurrency = this.currencyData.find((x: any) => x.target_currency === currency);
        if (selectedCurrency) {
          this.selectedCurrency = selectedCurrency;
          this.target_currency_rate = selectedCurrency.rate;
          this.currency = selectedCurrency.target_currency;
          this.target_fav_icon = selectedCurrency.target_currency_fav_icon;
          this.target_currency_symbol = selectedCurrency.target_currency_symbol;
        }
      }
    })


    }
  }

  /**
   * Legacy method.
   * To be removed once getTopLocationsV2 and tested and stable
   */
  getTopLocations() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "location";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.locationAPiCalled = true;
      const tempData = response?.data?.aggregations?.location;
      this.totalResultCount = response.data.totalresultscount;
      this.locationSortData = tempData;
      this.totalCount = tempData.length;
      this.locationsData = this.locationSortData?.slice(this.start, this.end);
      this.locations = new MatTableDataSource(this.locationsData);
      this.locations.sort = this.locationTbSort;
      this.markMap();
      this.manualSort();
      this.getlocationsai(this.locationSortData);
      //  if(!this.filterData || (this.filterData?.filterType == 'location' || this.filterData?.filterType == 'industry' || this.filterData?.filterType == 'company' || this.filterData?.filterType == 'seniority' || this.filterData?.filterType == 'function' || this.filterData?.filterType == 'locationRange' || this.filterData?.filterType == 'skills' || this.filterData?.filterType == 'jobtitle' || this.filterData?.filterType == 'keyword')) {
      this.setLocationJobAggregates();
      // }
    });
  }

  getTopLocationsV2() {
    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const request = this.aggService.getRequestWithFilters();
    request.aggregatetype = "location-recenthires";
    request.aggregatescount = this.aggregatescount;

    this.personSearchService.getTotalAggs(request, true).subscribe(response => {
      this.locationAPiCalled = true;
      const tempData = response?.data?.aggregations && response?.data?.aggregations["location-recenthires"]
        ? response?.data?.aggregations["location-recenthires"] : [];
      this.totalResultCount = response.data.totalresultscount;
      this.locationSortData = tempData;
      this.totalCount = tempData.length;
      this.locationsData = this.locationSortData?.slice(this.start, this.end);
      this.locations = new MatTableDataSource(this.locationsData);
      this.locations.sort = this.locationTbSort;
      this.markMap();


      this.manualSort();
      this.getlocationsai(this.locationSortData);
      this.setLocationJobAggregates();


    });
  }

  /**
   * Mark locations on page according to data on each page
   */
  markMap() {
    const CharForworkCountry = [];
    CharForworkCountry.push(['Location', 'Professional count'])
    this.locationsData.forEach(x => {
      const dataObj = [`${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`, x.doc_count];
      CharForworkCountry.push(dataObj);
    });
    this.dataSourceWorkCountry = CharForworkCountry;
    setTimeout(() => {
      this.loadGoogleMap();
    });
  }

  /**
   *
   */
  loadGoogleMap() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq = this.aggService.getRequestWithFilters();
    const continent = Array.isArray(aggReq.continentstobeincluded) ? aggReq.continentstobeincluded[0] : aggReq.continentstobeincluded;

    function drawMarkersMap() {
      var data = google.visualization.arrayToDataTable(this.dataSourceWorkCountry);
      var options = {
        region: `world`,
        displayMode: 'markers',
        colorAxis: { colors: this.fusionChartService.LOCATION_COLOR_PALETTE },
        magnifyingGlass: { enable: true, zoomFactor: 7.5 },
      };
      const container = document.getElementById('workCountryChart');
      var chart = new google.visualization.GeoChart(container);
      chart.draw(data, options);
    }

    google.charts.load('current', {
      'packages': ['geomap', 'geochart'],
      'mapsApiKey': environment.mapskey
    });
    google.charts.setOnLoadCallback(drawMarkersMap.bind(this));
  }

  manualSort() {
    this.reSortArr(this.locationTbSort);
  }

  /**Sort the data from all the pages present inititally */
  reSortArr(sort: MatSort) {
    const tempData = this.locationSortData;
    if (!this.hasSortSelection(sort)) {
      this.setDefaultLocationData(tempData);
      return;
    }
    this.setLocationSortData(tempData, sort);
    this.setSortedLocationData();
    this.markMap();
  }

  private setLocationSortData(tempData: any, sort: MatSort) {
    this.locationSortData = tempData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'recent_hires': return this.compare(a.recenthires, b.recenthires, isAsc);
        case 'job_doc_count': return this.compare(a.job_doc_count, b.job_doc_count, isAsc);
        default: return 0;
      }
    });
  }

  private setDefaultLocationData(tempData: any) {
    this.locationsData = tempData.slice(this.start, this.end);
    this.locations = new MatTableDataSource(this.locationsData);
    this.locations.sort = this.locationTbSort;
  }

  private setSortedLocationData() {
    this.locationsData = this.locationSortData.slice(this.start, this.end);
    this.locations = new MatTableDataSource(this.locationsData);
    this.locations.sort = this.locationTbSort;
  }

  private hasSortSelection(sort: MatSort) {
    return sort && sort.active && sort.direction;
  }

  compare(a, b, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
   *
   * @param index returns the index of current page
   */
  setPage(index: number) {
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    this.manualSort();
    // this.getCombinedAggregates();


  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    if (this.isLocationEurope) return;

    this.filters = this.filterDataHandlerService.fetchFilterData;

      const redirectFilters: Partial<FilterParams> = {
        insightsFilterData: this.filters,
      };

      switch (type) {
         case 'location': redirectFilters['mandatorylocations'] = [key]; break;
      case 'recent_hires': {
        redirectFilters['mandatorylocations'] = [key];
        redirectFilters['recentcompanyhires'] = true;
        break;
      }
      }

     const aggReq = this.aggService.getRequestWithFilters();
      if (aggReq?.continentstobeincluded) {
        redirectFilters['continentstobeincluded'] = aggReq.continentstobeincluded;
      }
      if (aggReq?.nlsearchquery) {
        redirectFilters['nlsearchquery'] = aggReq.nlsearchquery;
      }

      const uniqueKey = this.hashService.generateUniqueHash();
      localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

      // Forward the SAME UNIQUE_HASH this page was loaded with, so the listing page's
      // jdDataFromSession getter finds job_description-${jdUniqueHash} in the sessionStorage
      // that window.open() clones into the new tab.
      const jdUniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);

      let url = `/candidate-list?type=search&redirectSource=talent-insights&key=${uniqueKey}`;

      if ((this.isComingFromJD || this.isComingFromNLSearch) && jdUniqueHash) {
        url += `&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${jdUniqueHash}`;
      }

      window.open(url, '_blank');


  }

  getlocationsai(data) {
    let locationsdata: { 'Top Cities': string, 'Talent Count': number, 'Recent Hires': number, job_doc_count: number, 'salary offered max'?: number, 'salary offered min'?: number }[];
    locationsdata = data.map(x => ({
      'Top Cities': x.key,
      'Talent Count': x.doc_count,
      'Recent Hires': x.recenthires,
      'Job Post': x.job_doc_count || 0,
      ...(x.median_salary_max != null && { 'median salary offered max': x.median_salary_max }),
      ...(x.median_salary_min != null && { 'median salary offered min': x.median_salary_min }),
    }));
    this.modifyCurrencyDataForAi(locationsdata);
    this.locationsdataAI = {
      locations: locationsdata
    }
    if (this.locationsData.length == 0)
      this.locationsdataAI = null;
  }

  /**
   * Format currency data
   * @param aiData Already formatted ai data
   * @returns
   */
  modifyCurrencyDataForAi(aiData) {
    if (!aiData || !Array.isArray(aiData)) {
      return;
    }
    aiData.forEach(item => {
      if (item['median salary offered max']) {
        item['median salary offered max'] = item['median salary offered max'] * this.target_currency_rate;
      }
      if (item['median salary offered min']) {
        item['median salary offered min'] = item['median salary offered min'] * this.target_currency_rate;
      }
      if (this.selectedCurrency?.target_currency) {
        item['Salary currency'] = this.selectedCurrency?.target_currency
      }
    })
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if (requestData?.data?.currentTab !== this.talentInsightsService.INSIGHTS_TABS.LOCATION) return;

    //Must follows correct order
    this.tableHeaderName = [this.tableHeaderObj['TopCities'], this.tableHeaderObj['TalentCount'], this.tableHeaderObj['1yrGrowth'], this.tableHeaderObj['JobDemand'], this.tableHeaderObj['MedianSalary']];
    const locationDataForExport = this.locationSortData.map(location => {
      return {
        ...location,
        job_doc_count: location.job_doc_count || '—',
        median_salary: location.median_salary != 'N/A' ? location.median_salary : '—',
      }
    });

    const payloadForInsightsExport = {

      tab: 'location',
      totalresultcount: this.totalResultCount,
      chartdetails: [{ type: 'google', data: this.dataSourceWorkCountry }],
      locations: locationDataForExport,
      tableHeader: this.tableHeaderName,
      currencySymbol: this.target_currency_symbol
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  getCombinedAggregates() {
    this.hasJobDemand = true;
    this.hasMedianSalary = true;
    this.locationSortData = this.locationSortData.map(location => {
      location.median_salary = "";
      location.confidence_score = "";
      location.job_doc_count = '';
      return location;
    });
    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const request = this.aggService.getRequestWithFilters();
    request.aggregatetype = "jobs_base_aggregates";
    request.aggregatescount = 50;
    this.personSearchService.getTotalAggs(request).subscribe(response => {
      this.locationAPiCalled = true;
      const tempData = response?.data?.aggregations;
      this.combinedAggregates = tempData;
      this.combinedIndustry = this.combinedAggregates['current_industry'];
      this.combinedSkills = this.combinedAggregates['skills'];
      this.combinedJobtitle = this.combinedAggregates['current_jobtitle'];
      this.getJobsAggregates();
    });
  }

  getJobsAggregates() {
    this.hasMedianSalary = true;
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions')
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'location-median_salary',
      startindex: 0,
      resultsize: 50,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations || [],
      industries: aggReq?.industries || [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
      aggregatescount: 50,
        excluded_functions: aggReq?.exclude_functions || [],
excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],
    }
       if(this.isComingFromJD || this.isComingFromNLSearch){
            payload['jobDescriptionKeys'] = {
            jobtitles: jobtitles,
            mandatory_jobtitles: aggReq?.job_description_keys?.mandatory_job_titles || [],
            skills: skills,
            mandatory_skills: aggReq?.job_description_keys?.mandatory_skills || [],
            locations: aggReq?.job_description_keys?.locations || [],
            mandatory_locations: aggReq?.job_description_keys?.mandatory_locations || [],
            mandatory_company_sizes: aggReq?.job_description_keys?.mandatory_company_sizes || [],
            companies: aggReq?.job_description_keys?.companies || [],
            mandatory_companies: aggReq?.job_description_keys?.mandatory_companies || [],
            industries: aggReq?.job_description_keys?.industries || [],
            mandatory_industries: aggReq?.job_description_keys?.mandatory_industries || []
        }
        payload.jobtitles = _.uniq(aggReq?.jobtitles.concat(aggReq?.pastjobtitles)) || [];
        payload.skills = _.uniq(aggReq?.preferredskills?.concat(aggReq?.mandatoryskills)) || [];
       }
           this.locationTabPayload = payload

    if (jobtitles?.length > 0 && skills?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
        this.hasJobDemand = false;
        this.hasMedianSalary = false;
        this.locationSortData.map(location => {
          location.median_salary = "N/A";
          location.job_doc_count = 0;
          return location;
        });
        this.getlocationsai(this.locationSortData);
      } else if(!this.isComingFromJD && !this.isComingFromNLSearch && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')){
 this.hasJobDemand = false;
        this.hasMedianSalary = false;
        this.locationSortData.map(location => {
          location.median_salary = "N/A";
          location.job_doc_count = 0;
          return location;
        });
        this.getlocationsai(this.locationSortData);
      }

      else {
        this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
          const tempData = response?.data?.aggregations['location-median_salary'];
          this.locationJobAggregates = tempData;
          this.hasJobDemand = false;
          this.hasMedianSalary = false;
          this.setLocationJobAggregates();

          this.getlocationsai(this.locationSortData);

        })
      }

    } else {
      this.hasJobDemand = false;
      this.hasMedianSalary = false;
      this.locationSortData.map(location => {
        location.median_salary = "N/A";
        location.job_doc_count = "__";
        return location;
      });
      this.getlocationsai(this.locationSortData);

    }
  }

formatNumber(value: number): string| number {
  if (value === null || value === undefined || isNaN(value)) return '0';

  const country = this.localstorageservice.getItem('currencyCountry');
  const absNum = Math.abs(value);

  const format = (num: number) => {
    return num % 1 === 0 ? num.toString() : num.toFixed(1);
  };

  if (country?.toLowerCase() === 'india') {

    if (absNum >= 1e7) { // 1,00,00,000
      return format(value / 1e7) + 'Cr';
    }

    if (absNum >= 1e5) { // 1,00,000
      return format(value / 1e5) + 'L';
    }

    if (absNum >= 1e3) {
      return format(value / 1e3) + 'K';
    }

    return value;
  }

  else {

    if (absNum >= 1e9) {
      return format(value / 1e9) + 'B';
    }

    if (absNum >= 1e6) {
      return format(value / 1e6) + 'M';
    }

    if (absNum >= 1e3) {
      return format(value / 1e3) + 'K';
    }

    return value;
  }
}

  getCurrency() {
    this.hasMedianSalary = true;
    this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
      this.currencyData = response?.data;
      this.filteredCurrencies = this.currencyData.slice(0, 5);
      const currency = this.localstorageservice.getItem('jobCurrency');
      if (currency) {
        const selectedCurrency = this.currencyData.find((x: any) => x.target_currency === currency);
        if (selectedCurrency) {
          this.selectedCurrency = selectedCurrency;
          this.target_currency_rate = selectedCurrency.rate;
          this.currency = selectedCurrency.target_currency;
          this.target_fav_icon = selectedCurrency.target_currency_fav_icon;
          this.target_currency_symbol = selectedCurrency.target_currency_symbol;
        }
      }
      this.getJobsAggregates()
    })
  }

  onTypeAheadSearch(event: any) {
    const input = event.target.value.toLowerCase();
    this.filteredCurrencies = this.currencyData.filter(x => x.target_currency.toLowerCase().includes(input));
    this.filteredCurrencies = this.filteredCurrencies.slice(0, 5);
  }

  selectedItem(currencyItem: any) {
    this.selectedCurrency = currencyItem;
    this.target_currency_rate = currencyItem.rate;
    this.currency = currencyItem.target_currency;
    this.target_fav_icon = currencyItem.target_currency_fav_icon;
    this.target_currency_symbol = currencyItem.target_currency_symbol;
    this.localstorageservice.setItem('jobCurrency', this.currency);
    this.locationSortData = this.locationSortData.map(location => {
      if (this.target_fav_icon == 'fa-money-bill') {
        location.median_salary = location.median_salary_min ? `${this.currency} ${this.formatNumber((location.median_salary_min) * this.target_currency_rate)} - ${this.currency} ${this.formatNumber(location.median_salary_max * this.target_currency_rate)}` : "N/A";

      } else {
        location.median_salary = location.median_salary_min ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((location.median_salary_min) * this.target_currency_rate)} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(location.median_salary_max * this.target_currency_rate)}` : "N/A";
      }
      return location;
    });
    this.getlocationsai(this.locationSortData);
  }

  clearCurrency() {
    this.selectedCurrency = null;
    this.currency = null;
    this.filteredCurrencies = this.currencyData.slice(0, 5);
  }

  getCurrencyData(source?: string) {
    const filterData = this.filterDataHandlerService.fetchFilterData;
    const aggReq = this.aggService.getRequestWithFilters();

    if (filterData && filterData.locationSelectedList.length > 0) {
      if (source === 'filterChange') {
        const locations = filterData.locationSelectedList.map(loc => loc.key.replace('.searchastext', ''));
        const location = locations.join(',');
        const payload = { locations: locations }
        this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
          if (res.status === 'success' && res.data) {
            this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
            this.localstorageservice.setItem('currencyCountry', res.data.country_name);
            this.setUpdatedData();
          }
        })
      } else {
        const currency = this.localstorageservice.getItem('jobCurrency') || 'USD';
        this.currency = currency;
        this.setUpdatedData();
      }
    } else if (this.jdService.isComingFromJobDescription) {
      if (source === 'jdUpdate') {
        if (aggReq && aggReq?.job_description_keys && aggReq?.job_description_keys?.locations?.length > 0) {
          const locations = aggReq.job_description_keys?.locations;
          const payload = { locations: locations }
          this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
            if (res.status === 'success' && res.data) {
              this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
              this.localstorageservice.setItem('currencyCountry', res.data.country_name);
              this.setUpdatedData();
            }
          })
        }
      }
      else {
        this.currency = this.localstorageservice.getItem('jobCurrency') || 'USD';
        this.setUpdatedData();
      }


    } else {
      const currency = this.localstorageservice.getItem('jobCurrency') || 'USD';
      this.currency = currency;
      this.setUpdatedData();

    }

  }
  /**
   * Retrun true if data is still pending
   */
  getDataPendingStatus() {
    return this.hasMedianSalary || this.hasJobDemand;
  }
  setLocationJobAggregates() {
    const aggReq = this.aggService.getRequestWithFilters();
   this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions');
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    if(skills?.length > 0 && jobtitles?.length > 0) {
        const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
         this.locationSortData.map(location => {
        location.median_salary = "N/A";
        location.confidence_score = "N/A";
        location.job_doc_count = 0;
        return location;
      });
      } else {
              this.locationSortData.map(location => {
        const medianSalaryData = this.locationJobAggregates?.find(item => item.key.toLowerCase().trim() === location.key.toLowerCase().trim());
        if (medianSalaryData) {
          if (this.target_fav_icon == 'fa-money-bill') {
            location.median_salary = medianSalaryData.median_salary_min.value ? `${this.currency} ${this.formatNumber((medianSalaryData.median_salary_min.value) * this.target_currency_rate)} - ${this.currency} ${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate)}` : "N/A";

          } else {
            location.median_salary = medianSalaryData.median_salary_min.value ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((medianSalaryData.median_salary_min.value) * this.target_currency_rate)} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate)}` : "N/A";
          }
          location.median_salary_min = medianSalaryData.median_salary_min.value;
          location.median_salary_max = medianSalaryData.median_salary_max.value;
          location.confidence_score = medianSalaryData.confidence_score;
          location.job_doc_count = medianSalaryData?.job_demand?.doc_count || 0;
        } else {
          location.median_salary = "N/A";
          location.confidence_score = "N/A";
          location.job_doc_count = 0;
        }
        return location;
      });
      }
    } else {
            this.locationSortData.map(location => {
        location.median_salary = "N/A";
        location.confidence_score = "N/A";
        location.job_doc_count = 0;
        return location;
      });
    }

    }



  openJoblistSlider(value) {
    Object.assign(this.locationTabPayload, {mandatory_locations:[value]})
      this.sendDataToSliderSubject.next(this.locationTabPayload);

      this.toOpenSliderFromTabSubject.next({isOpen:true})
  }

}



